import {expressApi} from '@/api/axiosClients';

export async function getBlogPosts(params = {}) {
  try {
    const result = await expressApi.get(`/v1/blog/posts`, {params});
    if (!result.status || result.status !== 200) {
      console.error('Server Error');
      return;
    }
    if (result.data.error) {
      console.error(result.data.message || 'Unknown Error');
      return;
    }
    return result.data;
  } catch (e) {
    console.error(e);
  }
}